import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
// import PageManager from "../../page-manager";
import BaseProduct from "./components/BaseProduct";
import ConfigurationOptions from "./components/ConfigurationOptions";
import useUtils from "./hooks/useUtils";
import useAPI from "./hooks/useAPI";
import useBCStorefront from "./hooks/useBCStorefront";
import Price from "./components/Price";
import useSettings from "../hooks/useSettings";

const Configurator = (props) => {
  const settings = useSettings();
  console.log("props helllo", props);
  const [baseProduct, setBaseProduct] = useState(null);
  const [configuration, setConfiguration] = useState(null);
  const [savedConfiguration, setSavedConfiguration] = useState(null);
  const [isConfigurationProductAlready, setIsConfigurationProductAlready] =
    useState(false);
  const [configurationProductId, setConfigurationProductId] = useState(null);
  const [totalCostOfConfiguration, setTotalCostOfConfiguration] = useState(0);
  const [cartItemId, setCartItemId] = useState(null);
  const [cartId, setCartId] = useState(null);
  const [
    isCreatingConfigurationAndAddingToCart,
    setIsCreatingConfigurationAndAddingToCart,
  ] = useState(false);
  const { calculateTotalCostOfConfiguration } = useUtils();
  const { API } = useAPI();
  const { BCStorefront } = useBCStorefront();

  useEffect(() => {
    let params = new URL(document.location).searchParams;
    let serverProductId = params.get("baseId");
    let configurationProductId = params.get("configurationProductId");
    console.log("params", params, serverProductId, configurationProductId);
    if (serverProductId) {
      getAndSetBaseProduct(serverProductId);
    } else if (configurationProductId) {
      getAndSetBaseProductAndSavedConfiguration(configurationProductId);
      let cartItemId = params.get("cartItemId");
      setCartItemId(cartItemId);
      let cartId = params.get("cartId");
      setCartId(cartId);
    } else {
    }
  }, []);

  useEffect(() => {
    setTotalCostOfConfiguration(
      calculateTotalCostOfConfiguration(configuration, baseProduct)
    );
  }, [configuration]);

  const getAndSetBaseProduct = async (baseProductId) => {
    let data = await API.get(`/bc/products/${baseProductId}`);
    if (data.product) {
      setBaseProduct(data.product);
    }
  };

  const getAndSetBaseProductAndSavedConfiguration = async (
    configurationProductId
  ) => {
    let data = await API.get(
      `/configuration/one?configurationProductBcId=${configurationProductId}`
    );
    let configuration = data.configuration;
    if (configuration) {
      await getAndSetBaseProduct(configuration.baseProductBcId);

      //Load the save configuration
      let savedConfiguration = {};
      configuration.selectedProducts.forEach((categoryProducts) => {
        let key = categoryProducts.categoryName;
        savedConfiguration[key] = {};
        savedConfiguration[key].selectedProducts = categoryProducts.products;
        savedConfiguration[key].category = {
          id: categoryProducts.categoryBcId,
          name: categoryProducts.categoryName,
        };
      });
      console.log("savedConfiguration", savedConfiguration);
      setSavedConfiguration(savedConfiguration);
      setConfigurationProductId(configuration.configurationProductBcId);
      setIsConfigurationProductAlready(true);
    }
    console.log("data", data);
  };

  const createConfigurationProductAndAddToCart = async () => {
    if (!baseProduct || !configuration) {
      return console.warn(
        "No base product or no configuration",
        baseProduct,
        configuration
      );
    }

    setIsCreatingConfigurationAndAddingToCart(true);

    let configurationProductBcId = await createConfigurationProduct();

    if (configurationProductBcId) {
      let shouldDeleteItemInCart =
        isConfigurationProductAlready && cartId && cartItemId;
      if (shouldDeleteItemInCart) {
        // Remove current from cart before adding the new config to cart
        await BCStorefront.del(`/carts/${cartId}/items/${cartItemId}`);

        // ?Optional... Delete old config product (or inactivate somehow?) - does deleting remove compeltely?
      }

      addToCart(configurationProductBcId);
    }
  };

  const createConfigurationProduct = async () => {
    //create the json the server expects
    let data = {};
    data.productBcId = baseProduct.id;
    data.selectedProducts = [];

    for (let categoryName in configuration) {
      let categoryConfiguration = configuration[categoryName];
      let selectedProductData = {
        categoryName: categoryConfiguration.category.name,
        categoryBcId: categoryConfiguration.category.id,
      };
      let products = [];
      categoryConfiguration.selectedProducts.forEach((selectedProduct) => {
        products.push({
          name: selectedProduct.name,
          bcId: selectedProduct.id,
          price: selectedProduct.price,
          qty: selectedProduct.qty,
        });
      });
      selectedProductData.products = products;
      data.selectedProducts.push(selectedProductData);
    }

    console.log("configuration", configuration);
    console.log("data", data);

    //Add configuration to server which adds the product to BC and then we can add to cart
    let responseData = await API.post("/configuration", data);

    if (responseData && responseData.configurationProductBcId) {
      let configurationProductBcId = responseData.configurationProductBcId;
      console.log(
        "configurationProductBcId created",
        configurationProductBcId,
        responseData
      );
      return configurationProductBcId;
    }
    return null;
  };

  const addToCart = (configurationProductBcId) => {
    window.location.href = `/cart.php?action=add&product_id=${configurationProductBcId}`;
  };

  const createOrUpdateConfigurationProductAndSendPDF = async (
    email,
    tel,
    name,
    callback
  ) => {
    let configurationProductBcId = await createConfigurationProduct();
    console.log(
      "configurationProductBcId created as",
      configurationProductBcId
    );
    let url = `/configuration/pdf?email=${email}&tel=${tel}&name=${name}&configurationProductBcId=${configurationProductBcId}`;
    console.log("url", url);
    let responseData = await API.get(url);
    console.log("responseData", responseData);
    if (callback) {
      callback();
    }
  };

  return (
    <div className="container">
      {baseProduct && (
        <div>
          {/* <BaseProduct baseProduct={baseProduct} /> */}
          <ConfigurationOptions
            baseProduct={baseProduct}
            baseProductId={baseProduct.id}
            onConfigurationUpdated={(configuration) => {
              setConfiguration(configuration);
            }}
            savedConfiguration={savedConfiguration ? savedConfiguration : null}
            createOrUpdateConfigurationProductAndAddToCart={
              createConfigurationProductAndAddToCart
            }
            addToCartBtnText={
              isConfigurationProductAlready
                ? "Update Configuration"
                : "Add to Cart"
            }
            isCreatingConfigurationAndAddingToCart={
              isCreatingConfigurationAndAddingToCart
            }
            createOrUpdateConfigurationProductAndSendPDF={
              createOrUpdateConfigurationProductAndSendPDF
            }
          />
        </div>
      )}

      {settings.showTouchPoints && (
        <div>
          <div
            className="sb-display-flex"
            style={{ alignItems: "stretch", marginTop: "60px" }}
          >
            <div
              className="sb-display-flex sb-bg-orange"
              style={{ width: "60%", padding: "30px" }}
            >
              <div>
                <div>
                  <img
                    style={{ width: "40px", marginBottom: "5px" }}
                    src={window.cdn(
                      "/img/sb-theme/home/contact-points/chat-icon.png"
                    )}
                  />
                  <h1 className="sb-bg-orange">
                    Talk with our specialists, with 24/7 support.
                  </h1>
                </div>
                {/* <p>
                Looking for HPE experts? With 24/7 support, our team of experts
                are always ready to help.
              </p> */}
                <a href="/contact-us" className="sb-btn-link">
                  Chat with our team
                </a>
              </div>
            </div>
            <div style={{ width: "40%" }}>
              <img src={window.cdn("/img/sb-theme/product/contact.jpg")} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// export default class ReactDemo extends PageManager {
//   onReady() {
//     const container = $("#root")[0];
//     ReactDOM.render(<Configurator context={this.context} />, container);
//   }
// }

export default Configurator;
